export const getJsonBlobContent = <T = any>(blob: Blob): Promise<T> => {
  const IS_DEV = process.env.NODE_ENV === 'development'
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsText(blob, 'utf-8')
    reader.onload = () => {
      let result
      try {
        result = JSON.parse(reader.result as string)
      } catch (error) {
        IS_DEV && console.error('JSON序列化失败')
        reject()
      }
      resolve(result as T)
    }
    reader.onerror = () => {
      IS_DEV && console.error('FileReader加载失败')
      reject()
    }
  })
}
